<div *ngIf="data?.calculations?.length > 0" class="content-container">
  <ion-grid data-cy="order-calculations-container" #calculationsContainer>
    <ion-row
      *ngFor="let item of data?.calculations; let i = index"
      [attr.data-cy]="'calculations-item-' + i"
    >
      <div [attr.data-cy]="item?.dataCy">
        <div
          class="calculation-row"
          *appShowSplit="item?.displayFlags"
          [attr.data-cy]="item?.dataCy + '-content'"
        >
          <div
            class="calculation-title"
            [attr.data-cy]="item?.dataCy + '-title'"
          >
            {{ item?.title }}
          </div>
          <div
            class="calculation-value"
            [attr.data-cy]="item?.dataCy + '-calculatedValue'"
          >
            <div *ngIf="item?.dollarAmount; else percentage">
              <span *ngIf="item?.calculatedValue === 0; else dollarAmount"
                >$0</span
              >
              <ng-template #dollarAmount>
                {{ item?.calculatedValue | formatCurrencyAndDecimalPipe }}
              </ng-template>
            </div>
            <ng-template #percentage>
              {{ item?.calculatedValue }}%
            </ng-template>
          </div>
        </div>
      </div>
    </ion-row>
  </ion-grid>

  <div class="info-icon-container" *ngIf="data?.calculations?.length > 0">
    <ng-container *ngIf="!isTouchExperience">
      <ion-icon
        name="information-circle-outline"
        color="primary"
        [id]="'hover-trigger'"
        [attr.data-cy]="'info-icon-hover'"
      ></ion-icon>
      <!-- Desktop/Non-touch: Hover trigger -->
      <ion-popover
        *ngIf="!isTouchExperience"
        class="order-calc-messages-popover"
        mode="ios"
        [trigger]="'hover-trigger'"
        triggerAction="hover"
        [attr.data-cy]="'info-popover-hover'"
      >
        <ng-template>
          <ion-content
            class="ion-padding tooltip-content"
            data-cy="info-popover-content"
          >
            <div class="tooltip-section">
              <div class="tooltip-title">
                {{ 'i18n.orderInsightsPage.cookbookAdoptionTitle' | translate }}
              </div>
              <div class="tooltip-description">
                {{
                  'i18n.orderInsightsPage.cookbookAdoptionTooltip' | translate
                }}
              </div>
            </div>

            <hr class="tooltip-divider" />

            <div class="tooltip-section">
              <div class="tooltip-title">
                {{ 'i18n.orderInsightsPage.sgpTitle' | translate }}
              </div>
              <div class="tooltip-description">
                {{ 'i18n.orderInsightsPage.sgpTooltip' | translate }}
              </div>
            </div>

            <hr class="tooltip-divider" />

            <div class="tooltip-section">
              <div class="tooltip-title">
                {{ 'i18n.orderInsightsPage.dollarToTargetTitle' | translate }}
              </div>
              <div class="tooltip-description">
                {{ 'i18n.orderInsightsPage.toTargetTooltip' | translate }}
              </div>
            </div>
          </ion-content>
        </ng-template>
      </ion-popover>
    </ng-container>
    <ng-container *ngIf="isTouchExperience">
      <ion-icon
        name="information-circle-outline"
        color="primary"
        [id]="'click-trigger'"
        [attr.data-cy]="'info-icon-click'"
      ></ion-icon>
      <!-- Touch: Click trigger -->
      <ion-popover
        *ngIf="isTouchExperience"
        class="order-calc-messages-popover"
        mode="ios"
        [trigger]="'click-trigger'"
        triggerAction="click"
        [attr.data-cy]="'info-popover-click'"
      >
        <ng-template>
          <ion-content
            class="ion-padding tooltip-content"
            data-cy="info-popover-content"
          >
            <div class="tooltip-section">
              <div class="tooltip-title">
                {{ 'i18n.orderInsightsPage.cookbookAdoptionTitle' | translate }}
              </div>
              <div class="tooltip-description">
                {{
                  'i18n.orderInsightsPage.cookbookAdoptionTooltip' | translate
                }}
              </div>
            </div>

            <hr class="tooltip-divider" />

            <div class="tooltip-section">
              <div class="tooltip-title">
                {{ 'i18n.orderInsightsPage.sgpTitle' | translate }}
              </div>
              <div class="tooltip-description">
                {{ 'i18n.orderInsightsPage.sgpTooltip' | translate }}
              </div>
            </div>

            <hr class="tooltip-divider" />

            <div class="tooltip-section">
              <div class="tooltip-title">
                {{ 'i18n.orderInsightsPage.dollarToTargetTitle' | translate }}
              </div>
              <div class="tooltip-description">
                {{ 'i18n.orderInsightsPage.toTargetTooltip' | translate }}
              </div>
            </div>
          </ion-content>
        </ng-template>
      </ion-popover>
    </ng-container>
  </div>
</div>
